module.exports = __webpack_public_path__ + "static/media/img_card_3.bf9ce216.svg";